var R = require('ramda');
var m = require('mithril');
var Promise = require('bluebird');
var loaders = require('./loaders');
var io = require('../../libs/socketio');
var session = require('../../auth/models/session');

var trippedOrPendingReset = R.flip(R.contains)(['Alarm Tripped', 'Pending Alarm Reset']); //bool
var isActive = R.propSatisfies(trippedOrPendingReset, 'alarmStatus'); //bool

var alarmMonitor = {};
alarmMonitor.events = [];
alarmMonitor.activeAlarmCount = 0;
alarmMonitor.totalAlarmCount = 0;
alarmMonitor.activeAlarmRequestCount = 0;
alarmMonitor.summaryRequestCount = 0;
alarmMonitor.subscribedGroups = new Set();
alarmMonitor.requestPromise = null;
alarmMonitor.summaryPromise = null;
alarmMonitor.updateTimer = null;

function ensureSubscribedToGroups() {
  var user = session.user();
  var groups = user && Array.isArray(user.groups) ? user.groups : [];
  groups.forEach((g) => {
    if (!alarmMonitor.subscribedGroups.has(g['@rid'])) {
      io.emit('subscribeAlarmGroup', g['@rid'])
      alarmMonitor.subscribedGroups.add(g['@rid']);
    }
  });
}

function resubscribeToAlarmGroups() {
  // Alarm broadcasts use per-group Socket.IO rooms. Those rooms are tied to
  // the old connection, so recreate them as soon as the browser reconnects.
  alarmMonitor.subscribedGroups.clear();
  ensureSubscribedToGroups();
}

alarmMonitor.getEvents = function () {
  ensureSubscribedToGroups();

  if (!alarmMonitor.events.length) {
    return alarmMonitor.requestEvents()
  } else {
    return Promise.resolve(alarmMonitor.events);
  }
};

alarmMonitor.getSummary = function () {
  ensureSubscribedToGroups();
  if (alarmMonitor.summaryPromise) return alarmMonitor.summaryPromise;
  if (alarmMonitor.summaryRequestCount > 0) {
    return Promise.resolve({ active: alarmMonitor.activeAlarmCount, total: alarmMonitor.totalAlarmCount });
  }
  return alarmMonitor.requestSummary();
};

alarmMonitor.handleAlarmUpdate = function (updatedIncident) {
  if (alarmMonitor.updateTimer) return;
  alarmMonitor.updateTimer = setTimeout(function () {
    alarmMonitor.updateTimer = null;
    if (alarmMonitor.events.length > 0) {
      alarmMonitor.requestEvents();
    } else {
      alarmMonitor.requestSummary();
    }
  }, 250);
}

io.on('alarm-update', alarmMonitor.handleAlarmUpdate);
io.on('connect', resubscribeToAlarmGroups);

alarmMonitor.requestEvents = function () {
  if (alarmMonitor.requestPromise) return alarmMonitor.requestPromise;
  alarmMonitor.activeAlarmRequestCount++;
  alarmMonitor.events = [];
  alarmMonitor.requestPromise = loaders.requestWithLoader({
    method: 'GET',
    url: '/api/v1/incident/',
  })
  .then(function (response) {
    response.forEach(alarmRecord => {
      let repetatedRid = false;
      alarmMonitor.events.forEach(r => {
        if(r['@rid'] === alarmRecord['@rid']) repetatedRid = true
      })
      if(!repetatedRid) alarmMonitor.events.push(alarmRecord)
    })
    alarmMonitor.activeAlarmCount = 0;
    alarmMonitor.events.forEach(alarmItem => {
      if(isActive(alarmItem)) alarmMonitor.activeAlarmCount+= 1;
    });
    alarmMonitor.totalAlarmCount = alarmMonitor.events.length;

    m.redraw();
    return alarmMonitor.events;
  })
  .finally(function () {
    alarmMonitor.requestPromise = null;
  });
  return alarmMonitor.requestPromise;
};

alarmMonitor.requestSummary = function () {
  if (alarmMonitor.summaryPromise) return alarmMonitor.summaryPromise;
  alarmMonitor.summaryRequestCount++;
  alarmMonitor.summaryPromise = loaders.requestWithLoader({
    method: 'GET',
    url: '/api/v1/incident/summary',
  })
  .then(function (summary) {
    alarmMonitor.activeAlarmCount = Number(summary && summary.active ? summary.active : 0);
    alarmMonitor.totalAlarmCount = Number(summary && summary.total ? summary.total : 0);
    m.redraw();
    return summary;
  })
  .finally(function () {
    alarmMonitor.summaryPromise = null;
  });
  return alarmMonitor.summaryPromise;
};

module.exports = alarmMonitor;
